import { motion } from "framer-motion";
import { useContent } from "../../i18n/useContent";
import Button from "../ui/Button";
import Icon from "../ui/Icons";
import { Reveal, RevealGroup, revealItemVariants } from "../ui/Reveal";
import heroPhoto from "../../assets/photos/hero-highway-kenworth.jpg";
import cgmgLogoWhite from "../../assets/brand/cgmg-logo-white.png";
import "./Hero.css";

export function Hero() {
  const { hero, site } = useContent();

  return (
    <section id="inicio" className="hero hero--photo">
      <div className="hero-media" aria-hidden="true">
        <img src={heroPhoto} alt="" className="hero-media-img" />
        <div className="hero-media-scrim" />
        <svg className="hero-grain" aria-hidden="true">
          <filter id="heroGrain">
            <feTurbulence type="fractalNoise" baseFrequency="0.85" numOctaves="2" stitchTiles="stitch" />
            <feColorMatrix type="matrix" values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.05 0" />
          </filter>
          <rect width="100%" height="100%" filter="url(#heroGrain)" />
        </svg>
      </div>

      <div className="container hero-grid">
        <div className="hero-content">
          {/* The page's <h1> is the line that says what we do and where
              (what people search for); the big slogan below keeps its look. */}
          <Reveal as="h1" className="eyebrow on-dark hero-eyebrow" delay={0}>
            {hero.eyebrow}
          </Reveal>

          <Reveal as="p" delay={0.12} className="hero-title font-display">
            {hero.headline}
          </Reveal>

          <Reveal as="p" delay={0.24} className="hero-sub">
            {hero.subheadline}
          </Reveal>

          <Reveal delay={0.36} className="hero-ctas">
            <Button href="#contacto" variant="primary" arrow>
              {hero.ctaPrimary}
            </Button>
            <Button href="#flota" variant="secondary">
              {hero.ctaSecondary}
            </Button>
          </Reveal>

          <RevealGroup as="ul" className="hero-badges" delay={0.55} stagger={0.09}>
            {hero.badges.map((badge) => (
              <motion.li key={badge.id} variants={revealItemVariants}>
                <Icon name="check" size={16} />
                <span>{badge.text}</span>
              </motion.li>
            ))}
          </RevealGroup>
        </div>

        <div className="hero-brand-side" aria-hidden="true">
          <img src={cgmgLogoWhite} alt="" className="hero-brand-logo" />
          <p className="hero-brand-tagline">{site.motto}</p>
          <p className="hero-brand-caption">{site.city}</p>
        </div>
      </div>

      <a href="#nosotros" className="hero-scrollhint">
        <span>{hero.scrollHint}</span>
        <Icon name="chevronDown" size={18} />
      </a>
    </section>
  );
}

export default Hero;
